import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative bg-ink text-white overflow-hidden">
      <div className="noise-overlay" />
      <div className="relative max-w-[1280px] mx-auto px-6 lg:px-10">
        <div className="py-24 lg:py-32 border-b border-white/10">
          <p className="eyebrow text-mist mb-6">Ready to build a business that scales without you</p>
          <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-10">
            <h2 className="font-serif font-light text-5xl sm:text-6xl lg:text-7xl leading-[0.95] tracking-tight max-w-2xl">
              Let&rsquo;s talk about your operations.
            </h2>
            <Link
              to="/contact"
              data-testid="footer-cta"
              data-track="request-assessment-footer"
              className="group inline-flex items-center gap-2 bg-white text-ink px-7 py-4 rounded-full text-sm font-semibold hover:bg-cloud transition-colors duration-200 w-fit"
            >
              Request an Assessment
              <ArrowUpRight size={17} className="transition-transform duration-200 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </Link>
          </div>
        </div>

        <div className="py-14 grid grid-cols-2 md:grid-cols-4 gap-10">
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-2.5 mb-4">
              <span className="w-8 h-8 bg-white text-ink flex items-center justify-center font-serif text-lg">L</span>
              <span className="font-serif text-xl">Local Proof STL</span>
            </div>
            <p className="text-mist text-sm leading-relaxed max-w-xs">
              Operational performance assessments and implementation partnerships for established, owner-led service businesses.
            </p>
          </div>
          <div>
            <p className="eyebrow text-mist mb-4">Firm</p>
            <ul className="space-y-2.5 text-sm text-cloud">
              <li><Link to="/about" className="hover:text-white transition-colors">About</Link></li>
              <li><Link to="/about#founder" data-testid="footer-leadership-link" className="hover:text-white transition-colors">Leadership</Link></li>
              <li><Link to="/services" className="hover:text-white transition-colors">Services</Link></li>
              <li><Link to="/assessment" className="hover:text-white transition-colors">Assessment</Link></li>
            </ul>
          </div>
          <div>
            <p className="eyebrow text-mist mb-4">Resources</p>
            <ul className="space-y-2.5 text-sm text-cloud">
              <li><Link to="/insights" className="hover:text-white transition-colors">Insights</Link></li>
              <li><Link to="/portal" className="hover:text-white transition-colors">Client Portal</Link></li>
              <li><Link to="/contact" className="hover:text-white transition-colors">Contact</Link></li>
            </ul>
          </div>
          <div>
            <p className="eyebrow text-mist mb-4">Contact</p>
            <ul className="space-y-2.5 text-sm text-cloud">
              <li>St. Louis, Missouri</li>
              <li><a href="tel:+13142460787" data-testid="footer-phone-link" className="hover:text-white transition-colors">314-246-0787</a></li>
              <li><a href="mailto:jay@localproofstl.com" className="hover:text-white transition-colors">jay@localproofstl.com</a></li>
            </ul>
          </div>
        </div>

        <div className="py-8 border-t border-white/10 text-xs text-mist">
          <p>© {new Date().getFullYear()} Local Proof STL. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
